import { webinarFormatSchema } from "../../../../../utils/velidations";
import { Fragment, useState } from "react";
import { red } from "@mui/material/colors";
import { useSelector } from "react-redux";

import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  InputLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";

function Format({ data, setValue }) {
  const [helperText, setHelperText] = useState([]);
  const { loadings } = useSelector((state) => state.otherSlice);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    const result = webinarFormatSchema.safeParse(formData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) {
          groupedErrors[key] = [];
        }
        groupedErrors[key].push(issue.message);
      });
      setHelperText(groupedErrors);
      return;
    }
    setHelperText([]);
    data.format = formData;
    setValue("resources");
  };

  return (
    <Fragment>
      <Typography variant="typographyA">Format & Access</Typography>
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <Box>
          <InputLabel labelvariant="InputFieldB">Webinar Format *</InputLabel>
          <FormControl component="fieldset">
            <RadioGroup row name="format" defaultValue={data?.format?.format}>
              <FormControlLabel value="live" label="Live" control={<Radio />} />
              <FormControlLabel
                value="recorded"
                label="Recorded + Q&A"
                control={<Radio />}
              />
            </RadioGroup>
          </FormControl>
          {helperText?.format && (
            <Typography mt={1} color={red["500"]}>
              {helperText.format[0]}
            </Typography>
          )}
        </Box>
        <Box>
          <InputLabel labelvariant="InputFieldB">Access *</InputLabel>
          <FormControl component="fieldset">
            <RadioGroup row name="access" defaultValue={data?.format?.access}>
              <FormControlLabel
                value="public"
                label="Public"
                control={<Radio />}
              />
              <FormControlLabel
                value="private"
                label="Private"
                control={<Radio />}
              />
            </RadioGroup>
          </FormControl>
          {helperText?.access && (
            <Typography mt={1} color={red["500"]}>
              {helperText.access[0]}
            </Typography>
          )}
        </Box>
        <Stack direction="row" spacing={1}>
          <Button
            size="large"
            type="button"
            variant="contained"
            sx={{ minWidth: 150 }}
            disabled={loadings?.create}
            onClick={() => {
              setValue("schedule");
            }}
          >
            Back
          </Button>
          <Button
            size="large"
            type="submit"
            variant="contained"
            sx={{ minWidth: 150 }}
            disabled={loadings?.create}
            endIcon={
              loadings?.create && (
                <CircularProgress size={20} color="text" thickness={5} />
              )
            }
          >
            Next
          </Button>
        </Stack>
      </Stack>
    </Fragment>
  );
}

export default Format;
